var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PaginationController", {
        attrs: {
          getDataActionName: "getChainRechargeRequestsPagination",
          historyLimit: _vm.historyLimit,
          haveStartDate: true,
          isPagination: ""
        },
        scopedSlots: _vm._u([
          {
            key: "dataTable",
            fn: function() {
              return [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.rechargeRequests,
                    "hide-actions": "",
                    "disable-initial-sort": "",
                    "item-key": "_key"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("v-flex", [
                                    _vm._v(_vm._s(_vm.getRequestId(props.item)))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("v-flex", [
                                    _vm._v(
                                      _vm._s(props.item.clientName || "---")
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass:
                                        "caption grey--text text--darken-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            props.item.orgKey ||
                                              props.item.clientKey ||
                                              "---"
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatAmount(props.item)) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.item.chain || "---") +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-xs-left",
                              staticStyle: {
                                "word-break": "break-word",
                                "max-width": "220px"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(props.item.depositAddress || "---") +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-xs-left",
                              staticStyle: {
                                "word-break": "break-word",
                                "max-width": "240px"
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("v-flex", [
                                    _vm._v(_vm._s(_vm.getTxHash(props.item)))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.item.status || "---") +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  props.item.createTime
                                    ? _vm.toTimestampString(
                                        props.item.createTime
                                      )
                                    : "---"
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  props.item.lastModifiedTime
                                    ? _vm.toTimestampString(
                                        props.item.lastModifiedTime
                                      )
                                    : "---"
                                ) +
                                "\n          "
                            )
                          ])
                        ]
                      }
                    }
                  ])
                })
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.rechargeRequests,
          callback: function($$v) {
            _vm.rechargeRequests = $$v
          },
          expression: "rechargeRequests"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18cd2a6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18cd2a6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChainRechargeRequests.vue
// module id = null
// module chunks = 